import EmotionalArcs from './EmotionalArcs';
export default EmotionalArcs;
